import { render } from "./ModifiedSection.vue?vue&type=template&id=f280d21a"
import script from "./ModifiedSection.vue?vue&type=script&lang=js"
export * from "./ModifiedSection.vue?vue&type=script&lang=js"
script.render = render

export default script